<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <corporate-policies-title />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <corporate-policies-categories-card />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <corporate-policies-content />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <corporate-policies-subtitle />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <corporate-policies-subcontent />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <corporate-policies-ordering-card />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <corporate-policies-home-page-status-card />
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <hr>
      </b-col>
    </b-row>
    <template v-if="itemList.length > 0">
      <b-row>
        <b-col
          cols="12"
          md="12"
          class="mt-2 mb-2"
        >
          <h4>Alt Başlıklar</h4>
        </b-col>
      </b-row>
      <b-row
        v-for="(item,index) in itemList"
        :key="index"
        class="d-flex justify-content-center align-items-center"
      >
        <b-col>
          <b-form-group
            label="Başlık"
            :label-for="index+'_title'"
          >
            <b-form-input
              :id="index+'_title'"
              v-model="item.title"
              placeholder="Başlık"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="İçerik"
            :label-for="index+'_content'"
          >
            <b-form-input
              :id="index+'_content'"
              v-model="item.content"
              placeholder="İçerik"
            />
          </b-form-group>
        </b-col>
        <b-col md="auto">
          <b-button
            variant="flat-danger"
            class="btn-icon rounded-circle mr-1"
            @click="removeRow(item,index)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
          <b-button
            :disabled="itemList.length-1 !== index"
            variant="flat-success"
            class="btn-icon rounded-circle"
            @click="addRow()"
          >
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-col>
      </b-row>
    </template>
    <b-alert
      v-else
      show
    >
      <div class="alert-body mt-1 text-center">
        <feather-icon icon="InfoIcon" />
        Alt Başlık Eklenmedi.
        <div>
          <b-button
            size="sm"
            variant="primary"
            class="mt-1"
            @click="addRow"
          >
            <feather-icon icon="PlusIcon" />
            Ekle
          </b-button>
        </div>
      </div>
    </b-alert>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BFormInput, BAlert, BFormGroup,
} from 'bootstrap-vue'
import CorporatePoliciesTitle from '@/views/Admin/Corporate_policies/Elements/TitleCard.vue'
import CorporatePoliciesContent from '@/views/Admin/Corporate_policies/Elements/ContentsCard.vue'
import CorporatePoliciesSubcontent from '@/views/Admin/Corporate_policies/Elements/SubContentsCard.vue'
import CorporatePoliciesSubtitle from '@/views/Admin/Corporate_policies/Elements/SubtitleCard.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CorporatePoliciesCategoriesCard
from '@/views/Admin/Corporate_policies/Elements/CorporatePoliciesCategoriesCard.vue'
import CorporatePoliciesOrderingCard from '@/views/Admin/Corporate_policies/Elements/OrderingCard.vue'
import CorporatePoliciesHomePageStatusCard from '@/views/Admin/Corporate_policies/Elements/HomepageStatus.vue'

export default {
  name: 'CorporatePoliciesSubTitleForm',
  components: {
    CorporatePoliciesHomePageStatusCard,
    CorporatePoliciesOrderingCard,
    CorporatePoliciesCategoriesCard,
    BAlert,
    CorporatePoliciesSubtitle,
    CorporatePoliciesSubcontent,
    CorporatePoliciesContent,
    CorporatePoliciesTitle,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
  },
  computed: {
    itemData() {
      return this.$store.getters['corporatePolicies/dataItem']
    },
    itemList() {
      return this.$store.getters['corporatePoliciesItems/dataList']
    },
  },
  methods: {
    addRow() {
      this.itemList.push({
        id: null,
        title: null,
        content: null,
        id_corporate_policies: this.$route.params.id,
      })
    },
    removeRow(item, key) {
      if (item.id) {
        this.$swal({
          title: this.$store.state.app.removeTitle,
          text: this.$store.state.app.removeMessage,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$store.state.app.removeConfirm,
          cancelButtonText: this.$store.state.app.removeCancel,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.$store.dispatch('corporatePoliciesItems/removeData', item.id)
              .then(response => {
                if (response) {
                  this.$swal({
                    icon: 'success',
                    title: this.$store.state.app.removeResultTitle,
                    text: this.$store.state.app.removeResultMessage,
                    confirmButtonText: this.$store.state.app.removeResultClose,
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                  this.itemList.splice(key, 1)
                } else {
                  this.$swal({
                    icon: 'danger',
                    title: this.$store.state.app.removeResultTitle,
                    text: 'İşlem başarısız.',
                    confirmButtonText: this.$store.state.app.removeResultClose,
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                }
              })
          }
        })
      } else {
        this.itemList.splice(key, 1)
      }
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
